<template>
  <div class="login-image hvh-flex end w-100" :style="{ 'background-image': `url(${$loadImage(images[selectedImage])})` }">
    <div class="login-image-text hvh-flex column" :class="{ 'w-100 pl-5': selectedImage === 1 }">
      <div class="hvh-flex end grow-1 pt-4 pr-4">
        <img class="logo" :src="$loadImage(logoImage)" alt="ACTICS logo BY EVERSANA" />
      </div>
      <div class="hvh-flex column center grow-2" v-if="selectedImage === 0">
        <p class="big-font">Your<br />secret to<br />getting<br />ahead.</p>
        <p class="mt-3">
          Experience the power of AI-driven predictive analytics with<br />ready-to-deploy, real-time commercial services. ACTICS<br />cloud-based products help pharmaceutical innovators<br />optimize actions in product and patient journeys.
        </p>
      </div>
      <div class="hvh-flex column grow-2 ml-3" v-if="selectedImage === 1">
        <p class="for-medical-informat">FOR MEDICAL INFORMATION TEAMS</p>
        <p class="youre-quick">You're quick.</p>
        <p class="quickly-generate-se">
          Quickly generate, segment, and measure your product inquiry metrics with <span class="suisse-intl-bold">MEDInsights</span>. Track your operational metrics, <br />KPIs, and service levels to identify trends, data gaps, and gain
          <br />customer insights throughout the life-cycle of your products.
        </p>
      </div>
      <div class="hvh-flex column center grow-2" v-if="selectedImage === 2">
        <div class="images-container">
          <div>
            <img :src="$loadImage(awardLogoImage)" />
            <div></div>
          </div>
          <div>
            <div :style="{ 'margin-top': '65px' }"><img :src="$loadImage(awardWeAcceptTextImage)" /></div>
            <div class="we-accept_text">
              <span class="suisse-intl-bold">WINNER</span> <span class="suisse-intl-regular">of the</span> <span class="suisse-intl-bold-50d4df">2022 Artificial Intelligence Award</span>,<br />
              <span class="suisse-intl-bold">ACTICS</span>
              <span class="suisse-intl">
                by EVERSANA is pioneering next-generation<br />
                commercial services to the global life sciences industry.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logoImage: require('../../../assets/images/actics/logo_actics.png'),
      images: [
        require('../../../assets/images/actics/login/login-page.Actics.png'),
        require('../../../assets/images/actics/login/med-insights.Actics.png'),
        require('../../../assets/images/actics/login/ai-award.Actics.png')
      ],
      selectedImage: null,
      awardLogoImage: require('../../../assets/images/actics/login/ai-award/logo_award.png'),
      awardWeAcceptTextImage: require('../../../assets/images/actics/login/ai-award/we-accept_text.png'),
    };
  },
  created() {
    this.selectedImage = parseInt(localStorage.getItem("ActicsLoginImageIndex") || -1) + 1;
    if (this.selectedImage > 2) { this.selectedImage = 0; }
    localStorage.setItem("ActicsLoginImageIndex", this.selectedImage);
    return this.images[this.selectedImage];
  },
}
</script>

<style lang="scss" scoped>
.login-image {
  color: white;
  height: 100%;
  background-color: #000206;
  background-size: cover;

  .logo {
    width: 135px;
    height: 44px;
    margin: auto 0;
  }

  .login-image-text {
    overflow: hidden;
    margin-right: 48px;

    .big-font {
      font-size: 110px;
      line-height: 108px;
    }
  }
}

/*
div {
  border-style: solid;
  border-color: coral;
}
*/

.for-medical-informat {
  display: flex;
  justify-content: flex-start;

  color: #ffffff;
  font-family: "Suisse Int'l";
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 1.5px;
  line-height: 20px;
}

.youre-quick {
  color: #ffffff;
  font-family: "Suisse Int'l";
  font-size: 95px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 102px;
}

.quickly-generate-se {
  margin-top: 25px;
  height: 80px;
  width: 401px;
  color: #ffffff;
  font-family: "Suisse Int'l";
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 20px;
}

.images-container {
  display: flex;
  justify-content: center;
}

.images-container img {
  margin-left: 5px;
  margin-right: 5px;
}

.we-accept_text {
  margin-left: 20px;
  font-size: 11px;
  height: 60px;
  width: 466px;
  color: #ffffff;
  font-family: "Suisse Int'l Book";
  font-weight: 300;
  letter-spacing: 0;
}

.suisse-intl-bold {
  font-family: "Suisse Int'l Bold";
}

.suisse-intl-bold-50d4df {
  color: #50d4df;
  font-family: "Suisse Int'l Bold";
}

.suisse-intl-regular {
  font-family: "Suisse Int'l Regular";
}

.suisse-intl {
  font-family: "Suisse Int'l";
}

@media (max-width: 960px) {
  .login-image {
    display: none;
  }
}
</style>